<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";

// Stores
const modalStore = useModalStore();

// I18n
const { t } = useI18n();

onMounted(async () => { });
</script>

<template>
  <div class="justify-center items-center w-full">
    <div class="py-4 md:py-8">
      <div class="max-h-[558px] overflow-y-scroll terms_and_conditions">

        <h2>
          Terms and conditions
        </h2>
        <p>
          These terms and conditions ("Agreement") set forth the general terms and
          conditions of your use of the AutoWise.com website ("Website"), "AutoWise"
          mobile application ("Mobile Application") and any of their related products
          and services (collectively, "Services"). This Agreement is legally binding
          between you ("User", "you" or "your") and AutoWise ("AutoWise", "we", "us"
          or "our"). By accessing and using the Services, you acknowledge that you
          have read, understood, and agree to be bound by the terms of this
          Agreement. If you are entering into this Agreement on behalf of a business
          or other legal entity, you represent that you have the authority to bind
          such entity to this Agreement, in which case the terms "User", "you" or
          "your" shall refer to such entity. If you do not have such authority, or if
          you do not agree with the terms of this Agreement, you must not accept this
          Agreement and may not access and use the Services. You acknowledge that
          this Agreement is a contract between you and AutoWise, even though it is
          electronic and is not physically signed by you, and it governs your use of
          the Services.
        </p>
        <h2>
          Accounts and membership
        </h2>
        <p>
          You must be at least 16 years of age to use the Services. By using the
          Services and by agreeing to this Agreement you warrant and represent that
          you are at least 16 years of age.
        </p>
        <p>
          If you create an account on the Services, you are responsible for
          maintaining the security of your account and you are fully responsible for
          all activities that occur under the account and any other actions taken in
          connection with it. We may, but have no obligation to, monitor and review
          new accounts before you may sign in and start using the Services. Providing
          false contact information of any kind may result in the termination of your
          account. You must immediately notify us of any unauthorized uses of your
          account or any other breaches of security. We will not be liable for any
          acts or omissions by you, including any damages of any kind incurred as a
          result of such acts or omissions. We may suspend, disable, or delete your
          account (or any part thereof) if we determine that you have violated any
          provision of this Agreement or that your conduct or content would tend to
          damage our reputation and goodwill. If we delete your account for the
          foregoing reasons, you may not re-register for our Services. We may block
          your email address and Internet protocol address to prevent further
          registration.
        </p>
        <h2>
          User content
        </h2>
        <p>
          We do not own any data, information or material (collectively, "Content")
          that you submit on the Services in the course of using the Service. You
          shall have sole responsibility for the accuracy, quality, integrity,
          legality, reliability, appropriateness, and intellectual property ownership
          or right to use of all submitted Content. We may, but have no obligation
          to, monitor and review the Content on the Services submitted or created
          using our Services by you. You grant us permission to access, copy,
          distribute, store, transmit, reformat, display and perform the Content of
          your user account solely as required for the purpose of providing the
          Services to you. Without limiting any of those representations or
          warranties, we have the right, though not the obligation, to, in our own
          sole discretion, refuse or remove any Content that, in our reasonable
          opinion, violates any of our policies or is in any way harmful or
          objectionable. You also grant us the license to use, reproduce, adapt,
          modify, publish or distribute the Content created by you or stored in your
          user account for commercial, marketing or any similar purpose.
        </p>
        <h2>
          Billing and payments
        </h2>
        <p>
          You shall pay all fees or charges to your account in accordance with the
          fees, charges, and billing terms in effect at the time a fee or charge is
          due and payable.  Where Services are offered on a free trial basis, payment
          may be required after the free trial period ends, and not when you enter
          your billing details (which may be required prior to the commencement of
          the free trial period). If auto-renewal is enabled for the Services you
          have subscribed for, you will be charged automatically in accordance with
          the term you selected. Sensitive and private data exchange happens over a
          SSL secured communication channel and is encrypted and protected with
          digital signatures, and the Services are also in compliance with PCI
          vulnerability standards in order to create as secure of an environment as
          possible for Users. Scans for malware are performed on a regular basis for
          additional security and protection. If, in our judgment, your purchase
          constitutes a high-risk transaction, we will require you to provide us with
          a copy of your valid government-issued photo identification, and possibly a
          copy of a recent bank statement for the credit or debit card used for the
          purchase. We reserve the right to change products and product pricing at any
          time. We also reserve the right to refuse any order you place with us. We
          may, in our sole discretion, limit or cancel quantities purchased per
          person, per household or per order. These restrictions may include orders
          placed by or under the same customer account, the same credit card, and/or
          orders that use the same billing and/or shipping address. In the event that
          we make a change to or cancel an order, we may attempt to notify you by
          contacting the e-mail and/or billing address/phone number provided at the
          time the order was made.
        </p>
        <h2>
          Accuracy of information
        </h2>
        <p>
          Occasionally there may be information on the Services that contains
          typographical errors, inaccuracies or omissions that may relate to
          availability, promotions and offers. We reserve the right to correct any
          errors, inaccuracies or omissions, and to change or update information or
          cancel orders if any information on the Services or Services is inaccurate
          at any time without prior notice (including after you have submitted your
          order). We undertake no obligation to update, amend or clarify information
          on the Services including, without limitation, pricing information, except
          as required by law. No specified update or refresh date applied on the
          Services should be taken to indicate that all information on the Services
          or Services has been modified or updated.
        </p>
        <h2>
          Third party services
        </h2>
        <p>
          If you decide to enable, access or use third party services, be advised
          that your access and use of such other services are governed solely by the
          terms and conditions of such other services, and we do not endorse, are not
          responsible or liable for, and make no representations as to any aspect of
          such other services, including, without limitation, their content or the
          manner in which they handle data (including your data) or any interaction
          between you and the provider of such other services. You irrevocably waive
          any claim against AutoWise with respect to such other services. AutoWise is
          not liable for any damage or loss caused or alleged to be caused by or in
          connection with your enablement, access or use of any such other services,
          or your reliance on the privacy practices, data security processes or other
          policies of such other services. You may be required to register for or log
          into such other services on their respective platforms. By enabling any
          other services, you are expressly permitting AutoWise to disclose your data
          as necessary to facilitate the use or enablement of such other service.
        </p>
        <h2>
          Backups
        </h2>
        <p>
          We perform regular backups of the Website and its Content; however, these
          backups are for our own administrative purposes only and are in no way
          guaranteed. You are responsible for maintaining your own backups of your
          data. We do not provide any sort of compensation for lost or incomplete
          data in the event that backups do not function properly. We will do our
          best to ensure complete and accurate backups, but assume no responsibility
          for this duty.
        </p>
        <h2>
          Advertisements
        </h2>
        <p>
          During your use of the Services, you may enter into correspondence with or
          participate in promotions of advertisers or sponsors showing their goods or
          services through the Services. Any such activity, and any terms,
          conditions, warranties or representations associated with such activity, is
          solely between you and the applicable third party. We shall have no
          liability, obligation or responsibility for any such correspondence,
          purchase or promotion between you and any such third party.
        </p>
        <h2>
          Links to other resources
        </h2>
        <p>
          Although the Services may link to other resources (such as websites, mobile
          applications, etc.), we are not, directly or indirectly, implying any
          approval, association, sponsorship, endorsement, or affiliation with any
          linked resource, unless specifically stated herein. Some of the links on
          the Services may be "affiliate links". This means if you click on the link
          and purchase an item, AutoWise will receive an affiliate commission. We are
          not responsible for examining or evaluating, and we do not warrant the
          offerings of, any businesses or individuals or the content of their
          resources. We do not assume any responsibility or liability for the
          actions, products, services, and content of any other third parties. You
          should carefully review the legal statements and other conditions of use of
          any resource which you access through a link on the Services. Your linking
          to any other off-site resources is at your own risk.
        </p>
        <h2>
          Prohibited uses
        </h2>
        <p>
          In addition to other terms as set forth in the Agreement, you are
          prohibited from using the Services or Content: (a) for any unlawful
          purpose; (b) to solicit others to perform or participate in any unlawful
          acts; (c) to violate any international, federal, provincial or state
          regulations, rules, laws, or local ordinances; (d) to infringe upon or
          violate our intellectual property rights or the intellectual property
          rights of others; (e) to harass, abuse, insult, harm, defame, slander,
          disparage, intimidate, or discriminate based on gender, sexual orientation,
          religion, ethnicity, race, age, national origin, or disability; (f) to
          submit false or misleading information; (g) to upload or transmit viruses
          or any other type of malicious code that will or may be used in any way
          that will affect the functionality or operation of the Services, third party
          products and services, or the Internet; (h) to spam, phish, pharm, pretext,
          spider, crawl, or scrape; (i) for any obscene or immoral purpose; or (j) to
          interfere with or circumvent the security features of the Services, third
          party products and services, or the Internet. We reserve the right to
          terminate your use of the Services for violating any of the prohibited
          uses.
        </p>
        <h2>
          Intellectual property rights
        </h2>
        <p>
          "Intellectual Property Rights" means all present and future rights
          conferred by statute, common law or equity in or in relation to any
          copyright and related rights, trademarks, designs, patents, inventions,
          goodwill and the right to sue for passing off, rights to inventions, rights
          to use, and all other intellectual property rights, in each case whether
          registered or unregistered and including all applications and rights to
          apply for and be granted, rights to claim priority from, such rights and
          all similar or equivalent rights or forms of protection and any other
          results of intellectual activity which subsist or will subsist now or in
          the future in any part of the world. This Agreement does not transfer to
          you any intellectual property owned by AutoWise or third parties, and all
          rights, titles, and interests in and to such property will remain (as
          between the parties) solely with AutoWise. All trademarks, service marks,
          graphics and logos used in connection with the Services, are trademarks or
          registered trademarks of AutoWise or its licensors. Other trademarks,
          service marks, graphics and logos used in connection with the Services may
          be the trademarks of other third parties. Your use of the Services grants
          you no right or license to reproduce or otherwise use any of AutoWise or
          third-party trademarks.
        </p>
        <h2>
          Disclaimer of warranty
        </h2>
        <p>
          You agree that such Service is provided on an "as is" and "as available"
          basis and that your use of the Services is solely at your own risk. We
          expressly disclaim all warranties of any kind, whether express or implied,
          including but not limited to the implied warranties of merchantability,
          fitness for a particular purpose and non-infringement. We make no warranty
          that the Services will meet your requirements, or that the Service will be
          uninterrupted, timely, secure, or error-free; nor do we make any warranty
          as to the results that may be obtained from the use of the Service or as to
          the accuracy or reliability of any information obtained through the Service
          or that defects in the Service will be corrected. You understand and agree
          that any material and/or data downloaded or otherwise obtained through the
          use of Service is done at your own discretion and risk and that you will be
          solely responsible for any damage or loss of data that results from the
          download of such material and/or data. We make no warranty regarding any
          goods or services purchased or obtained through the Service or any
          transactions entered into through the Service unless stated otherwise. No
          advice or information, whether oral or written, obtained by you from us or
          through the Service shall create any warranty not expressly made herein.
        </p>
        <h2>
          Limitation of liability
        </h2>
        <p>
          To the fullest extent permitted by applicable law, in no event will
          AutoWise, its affiliates, directors, officers, employees, agents, suppliers
          or licensors be liable to any person for any indirect, incidental, special,
          punitive, cover or consequential damages (including, without limitation,
          damages for lost profits, revenue, sales, goodwill, use of content, impact
          on business, business interruption, loss of anticipated savings, loss of
          business opportunity) however caused, under any theory of liability,
          including, without limitation, contract, tort, warranty, breach of
          statutory duty, negligence or otherwise, even if the liable party has been
          advised as to the possibility of such damages or could have foreseen such
          damages. To the maximum extent permitted by applicable law, the aggregate
          liability of AutoWise and its affiliates, officers, employees, agents,
          suppliers and licensors relating to the services will be limited to an
          amount greater of one dollar or any amounts actually paid in cash by you to
          AutoWise for the prior one-month period prior to the first event or
          occurrence giving rise to such liability. The limitations and exclusions
          also apply if this remedy does not fully compensate you for any losses or
          fails of its essential purpose.
        </p>
        <h2>
          Indemnification
        </h2>
        <p>
          You agree to indemnify and hold AutoWise and its affiliates, directors,
          officers, employees, agents, suppliers and licensors harmless from and
          against any liabilities, losses, damages or costs, including reasonable
          attorneys' fees, incurred in connection with or arising from any third
          party allegations, claims, actions, disputes, or demands asserted against
          any of them as a result of or relating to your Content, your use of the
          Services or any willful misconduct on your part.
        </p>
        <h2>
          Severability
        </h2>
        <p>
          All rights and restrictions contained in this Agreement may be exercised
          and shall be applicable and binding only to the extent that they do not
          violate any applicable laws and are intended to be limited to the extent
          necessary so that they will not render this Agreement illegal, invalid or
          unenforceable. If any provision or portion of any provision of this
          Agreement shall be held to be illegal, invalid or unenforceable by a court
          of competent jurisdiction, it is the intention of the parties that the
          remaining provisions or portions thereof shall constitute their agreement
          with respect to the subject matter hereof, and all such remaining
          provisions or portions thereof shall remain in full force and effect.
        </p>
        <h2>
          Dispute resolution
        </h2>
        <p>
          The formation, interpretation, and performance of this Agreement and any
          disputes arising out of it shall be governed by the substantive and
          procedural laws of Arizona, United States without regard to its rules on
          conflicts or choice of law and, to the extent applicable, the laws of
          United States. The exclusive jurisdiction and venue for actions related to
          the subject matter hereof shall be the courts located in Arizona, United
          States, and you hereby submit to the personal jurisdiction of such courts.
          You hereby waive any right to a jury trial in any proceeding arising out of
          or related to this Agreement. The United Nations Convention on Contracts
          for the International Sale of Goods does not apply to this Agreement.
        </p>
        <h2>
          Assignment
        </h2>
        <p>
          You may not assign, resell, sub-license or otherwise transfer or delegate
          any of your rights or obligations hereunder, in whole or in part, without
          our prior written consent, which consent shall be at our own sole
          discretion and without obligation; any such assignment or transfer shall be
          null and void. We are free to assign any of its rights or obligations
          hereunder, in whole or in part, to any third party as part of the sale of
          all or substantially all of its assets or stock or as part of a merger.
        </p>
        <h2>
          Changes and amendments
        </h2>
        <p>
          We reserve the right to modify this Agreement or its terms relating to the
          Services at any time, effective upon posting of an updated version of this
          Agreement on the Services. When we do, we will post a notification within
          the Services.  Continued use of the Services after any such changes shall
          constitute your consent to such changes.
        </p>
        <h2>
          Acceptance of these terms
        </h2>
        <p>
          You acknowledge that you have read this Agreement and agree to all its
          terms and conditions. By accessing and using the Services you agree to be
          bound by this Agreement. If you do not agree to abide by the terms of this
          Agreement, you are not authorized to access or use the Services.
        </p>
        <h2>
          Contacting us
        </h2>
        <p>
          If you would like to contact us to understand more about this Agreement or
          wish to contact us concerning any matter relating to it, you may write a
          letter to 4960 S Gilbert Rd Ste 1-296, Chandler, AZ, 85249-5982
        </p>
        <h2>
          DMCA policy
        </h2>
        <p>
          This Digital Millennium Copyright Act policy ("Policy") applies to the
          AutoWise.com website ("Website"), "AutoWise" mobile application ("Mobile
          Application") and any of their related products and services (collectively,
          "Services") and outlines how AutoWise ("AutoWise", "we", "us" or "our")
          addresses copyright infringement notifications and how you ("you" or
          "your") may submit a copyright infringement complaint.
        </p>
        <p>
          Protection of intellectual property is of utmost importance to us, and we
          ask our users and their authorized agents to do the same. It is our policy
          to expeditiously respond to clear notifications of alleged copyright
          infringement that comply with the United States Digital Millennium
          Copyright Act ("DMCA") of 1998, the text of which can be found at the U.S.
          Copyright Office website.
        </p>
        <p>
          What to consider before submitting a copyright complaint
        </p>
        <p>
          Please note that under 17 U.S.C. § 512(f), you may be liable for any
          damages, including costs and attorneys’ fees incurred by us or our users,
          if you knowingly misrepresent that the material or activity is infringing.
          If you are unsure whether the material you are reporting is in fact
          infringing, you may wish to contact an attorney before filing a
          notification with us.
        </p>
        <p>
          We may, at our discretion or as required by law, share a copy of your
          notification or counter-notification with third parties. This may include
          sharing the information with the account holder engaged in the allegedly
          infringing activity or for publication. If you are concerned about your
          information being forwarded, you may wish to hire an agent to report
          infringing material for you.
        </p>
        <h2>
          Notifications of infringement
        </h2>
        <p>
          If you are a copyright owner or an agent thereof, and you believe that any
          material available on our Services infringes your copyrights, then you may
          submit a written copyright infringement notification ("Notification") using
          the contact details below pursuant to the DMCA by providing us with the
          following information:
        </p>
        <p>
          - Identification of the copyrighted work that you claim has been infringed,
          or, if multiple copyrighted works are covered by this Notification, you may
          provide a representative list of the copyrighted works that you claim have
          been infringed.
        </p>
        <p>
          - Identification of the infringing material and information you claim is
          infringing (or the subject of infringing activity), including at a minimum,
          if applicable, the URL or URLs of the web pages where the allegedly
          infringing material may be found.
        </p>
        <p>
          - Information reasonably sufficient to permit us to contact you, such as an
          address, telephone number, and, if available, an e-mail address.
        </p>
        <p>
          - A statement that you have a good faith belief that use of the material in
          the manner complained of is not authorized by the copyright owner, the
          copyright owner's agent, or the law.
        </p>
        <p>
          - A statement that the information in the notification is accurate, and
          under penalty of perjury that you are authorized to act on behalf of the
          owner of an exclusive right that is allegedly infringed.
        </p>
        <p>
          - A physical or electronic signature (typing your full name will suffice)
          of the copyright owner or a person authorized to act on their behalf.
        </p>
        <p>
          All such Notifications must comply with the DMCA requirements. You may
          refer to a DMCA takedown notice generator or other similar services to
          avoid making mistake and ensure compliance of your Notification.
        </p>
        <p>
          Filing a DMCA complaint is the start of a pre-defined legal process. Your
          complaint will be reviewed for accuracy, validity, and completeness. If
          your complaint has satisfied these requirements, our response may include
          the removal or restriction of access to allegedly infringing material as
          well as a permanent termination of repeat infringers’ accounts.
        </p>
        <p>
          If we remove or restrict access to materials or terminate an account in
          response to a Notification of alleged infringement, we will make a good
          faith effort to contact the affected user with information concerning the
          removal or restriction of access, which may include a full copy of your
          Notification (including your name, address, phone, and email address),
          along with instructions for filing a counter-notification.
        </p>
        <p>
          Notwithstanding anything to the contrary contained in any portion of this
          Policy, AutoWise reserves the right to take no action upon receipt of a
          DMCA copyright infringement notification if it fails to comply with all the
          requirements of the DMCA for such notifications.
        </p>
        <h2>
          Counter-notifications
        </h2>
        <p>
          A user who receives a copyright infringement Notification may make a
          counter-Notification pursuant to sections 512(g)(2) and (3) of the US
          Copyright Act. If you receive a copyright infringement Notification, it
          means that the material described in the Notification has been removed from
          our Services or access to the material has been restricted. Please take the
          time to read through the Notification, which includes information on the
          Notification we received as well as instructions on how to file a
          counter-notifications.
        </p>
        <p>
          To file a counter-notification with us, you must provide a written
          communication that sets out the information specified in the list below:
        </p>
        <p>
          - Identification of the material that has been removed or to which access
          has been restricted and the location at which the material appeared before
          it was removed or access to it was restricted.
        </p>
        <p>
          - Information reasonably sufficient to permit us to contact you, such as an
          address, telephone number, and, if available, an e-mail address.
        </p>
        <p>
          - A statement under penalty of perjury that you have a good faith belief
          that the material was removed or restricted as a result of mistake or
          misidentification of the material to be removed or restricted.
        </p>
        <p>
          - A statement that you consent to the jurisdiction of the federal district
          court for the judicial district in which the address is located (or if you
          are outside of the United States, that you consent to the jurisdiction of
          any judicial district in which the service provider may be found), and that
          you will accept service of process from the person or company who provided
          the original infringement notification.
        </p>
        <p>
          - A physical or electronic signature (typing your full name will suffice)
          of the copyright owner or a person authorized to act on their behalf.
        </p>
        <p>
          Please note that you may be liable for, including costs and attorneys’ fees
          incurred by us or our users, if you knowingly misrepresent that the
          material or activity is not infringing the copyrights of others or that the
          material or activity was removed or restricted by mistake or
          misidentification. Accordingly, if you are not sure whether certain
          material infringes the copyrights of others or that the material or
          activity was removed or restricted by mistake or misidentification, you may
          wish to contact an attorney before filing a counter-notification.
        </p>
        <p>
          Notwithstanding anything to the contrary contained in any portion of this
          Policy, AutoWise reserves the right to take no action upon receipt of a
          counter-notification. If we receive a counter-notification that complies
          with the terms of 17 U.S.C. § 512(g), we may forward it to the person who
          filed the original Notification.
        </p>
        <p>
          The process described in this Policy does not limit our ability to pursue
          any other remedies we may have to address suspected infringement.
        </p>
        <h2>
          Changes and amendments
        </h2>
        <p>
          We reserve the right to modify this Policy or its terms relating to the
          Services at any time, effective upon posting of an updated version of this
          Policy on the Services. When we do, we will post a notification within the
          Services.
        </p>
        <h2>
          Reporting copyright infringement
        </h2>
        <p>
          If you would like to notify us of the infringing material or activity, you
          may write a letter to 4960 S Gilbert Rd Ste 1-296, Chandler​, AZ,
          85249-5982
        </p>
        <h2>
          Acceptable use policy
        </h2>
        <p>
          This acceptable use policy ("Policy") sets forth the general guidelines
          and acceptable and prohibited uses of the AutoWise.com website ("Website"),
          "AutoWise" mobile application ("Mobile Application") and any of their
          related products and services (collectively, "Services"). This Policy is a
          legally binding agreement between you ("User", "you" or "your") and
          AutoWise ("AutoWise", "we", "us" or "our").  By accessing and using the
          Services, you acknowledge that you have read, understood, and agree to be
          bound by the terms of this Agreement. If you are entering into this
          Agreement on behalf of a business or other legal entity, you represent that
          you have the authority to bind such entity to this Agreement, in which case
          the terms "User", "you" or "your" shall refer to such entity. If you do not
          have such authority, or if you do not agree with the terms of this
          Agreement, you must not accept this Agreement and may not access and use
          the Services. You acknowledge that this Agreement is a contract between you
          and AutoWise, even though it is electronic and is not physically signed by
          you, and it governs your use of the Services.
        </p>
        <h2>
          Prohibited activities and uses
        </h2>
        <p>
          You may not use the Services to publish content or engage in activity that
          is illegal under applicable law, that is harmful to others, or that would
          subject us to liability, including, without limitation, in connection with
          any of the following, each of which is prohibited under this Policy:
        </p>
        <p>
          - Distributing malware or other malicious code.
        </p>
        <p>
          - Disclosing sensitive personal information about others.
        </p>
        <p>
          - Collecting, or attempting to collect, personal information about third
          parties without their knowledge or consent.
        </p>
        <p>
          - Distributing pornography or adult related content.
        </p>
        <p>
          - Promoting or facilitating prostitution or any escort services.
        </p>
        <p>
          - Hosting, distributing or linking to child pornography or content that is
          harmful to minors.
        </p>
        <p>
          - Promoting or facilitating gambling, violence, terrorist activities or
          selling weapons or ammunition.
        </p>
        <p>
          - Engaging in the unlawful distribution of controlled substances, drug
          contraband or prescription medications.
        </p>
        <p>
          - Managing payment aggregators or facilitators such as processing payments
          on behalf of other businesses or charities.
        </p>
        <p>
          - Facilitating pyramid schemes or other models intended to seek payments
          from public actors.
        </p>
        <p>
          - Threatening harm to persons or property or otherwise harassing behavior.
        </p>
        <p>
          - Manual or automatic credit card or other available payment methods
          testing using bots or scripts.
        </p>
        <p>
          - Purchasing any of the offered Services on someone else’s behalf.
        </p>
        <p>
          - Misrepresenting or fraudulently representing products or services.
        </p>
        <p>
          - Infringing the intellectual property or other proprietary rights of
          others.
        </p>
        <p>
          - Facilitating, aiding, or encouraging any of the above activities through
          the Services.
        </p>
        <h2>
          System abuse
        </h2>
        <p>
          Any User in violation of the Services security is subject to criminal and
          civil liability, as well as immediate account termination. Examples
          include, but are not limited to the following:
        </p>
        <p>
          - Use or distribution of tools designed for compromising security of the
          Services.
        </p>
        <p>
          - Intentionally or negligently transmitting files containing a computer
          virus or corrupted data.
        </p>
        <p>
          - Accessing another network without permission, including to probe or scan
          for vulnerabilities or breach security or authentication measures.
        </p>
        <p>
          - Unauthorized scanning or monitoring of data on any network or system
          without proper authorization of the owner of the system or network.
        </p>
        <h2>
          Service resources
        </h2>
        <p>
          You may not consume excessive amounts of the resources of the Services or
          use the Services in any way which results in performance issues, or which
          interrupts the Services for other Users. Prohibited activities that
          contribute to excessive use, include without limitation:
        </p>
        <p>
          - Deliberate attempts to overload the Services and broadcast attacks (i.e.
          denial of service attacks).
        </p>
        <p>
          - Engaging in any other activities that degrade the usability and
          performance of the Services.
        </p>
        <h2>
          No spam policy
        </h2>
        <p>
          You may not use the Services to send spam or bulk unsolicited messages. We
          maintain a zero-tolerance policy for use of the Services in any manner
          associated with the transmission, distribution or delivery of any bulk
          e-mail, including unsolicited bulk or unsolicited commercial e-mail, or the
          sending, assisting, or commissioning the transmission of commercial e-mail
          that does not comply with the U.S. CAN-SPAM Act of 2003 ("SPAM").
        </p>
        <p>
          Your products or services advertised via SPAM (i.e. Spamvertised) may not
          be used in conjunction with the Services. This provision includes, but is
          not limited to, SPAM sent via fax, phone, postal mail, email, instant
          messaging, or newsgroups.
        </p>
        <p>
          Sending emails through the Services to purchased email lists ("safe lists")
          will be treated as SPAM.
        </p>
        <h2>
          Defamation and objectionable content
        </h2>
        <p>
          We value the freedom of expression and encourage Users to be respectful
          with the content they post. We are not a publisher of User content and are
          not in a position to investigate the veracity of individual defamation
          claims or to determine whether certain material, which we may find
          objectionable, should be censored.  However, we reserve the right to
          moderate, disable or remove any content to prevent harm to others or to us
          or the Services, as determined in our sole discretion.
        </p>
        <h2>
          Copyrighted content
        </h2>
        <p>
          Copyrighted material must not be published via the Services without the
          explicit permission of the copyright owner or a person explicitly
          authorized to give such permission by the copyright owner. Upon receipt of
          a claim for copyright infringement, or a notice of such violation, we will
          immediately run full investigation and, upon confirmation, will notify the
          person or persons responsible for publishing it and, in our sole
          discretion, will remove the infringing material from the Services. We may
          terminate the Service of Users with repeated copyright infringements.
          Further procedures may be carried out if necessary. We will assume no
          liability to any User of the Services for the removal of any such material.
          If you believe your copyright is being infringed by a person or persons
          using the Services, please get in touch with us to report copyright
          infringement.
        </p>
        <h2>
          Security
        </h2>
        <p>
          You take full responsibility for maintaining reasonable security
          precautions for your account. You are responsible for protecting and
          updating any login account provided to you for the Services. You must
          protect the confidentiality of your login details, and you should change
          your password periodically.
        </p>
        <h2>
          Enforcement
        </h2>
        <p>
          We reserve our right to be the sole arbiter in determining the seriousness
          of each infringement and to immediately take corrective actions, including
          but not limited to:
        </p>
        <p>
          - Suspending or terminating your Service with or without notice upon any
          violation of this Policy. Any violations may also result in the immediate
          suspension or termination of your account.
        </p>
        <p>
          - Disabling or removing any content which is prohibited by this Policy,
          including to prevent harm to others or to us or the Services, as determined
          by us in our sole discretion.
        </p>
        <p>
          - Reporting violations to law enforcement as determined by us in our sole
          discretion.
        </p>
        <p>
          - A failure to respond to an email from our abuse team within 2 days, or as
          otherwise specified in the communication to you, may result in the
          suspension or termination of your account.
        </p>
        <p>
          Suspended and terminated User accounts due to violations will not be
          re-activated.
        </p>
        <p>
          Nothing contained in this Policy shall be construed to limit our actions or
          remedies in any way with respect to any of the prohibited activities. We
          reserve the right to take any and all additional actions we may deem
          appropriate with respect to such activities, including without limitation
          taking action to recover the costs and expenses of identifying offenders
          and removing them from the Services, and levying cancellation charges to
          cover our costs. In addition, we reserve at all times all rights and
          remedies available to us with respect to such activities at law or in
          equity.
        </p>
        <h2>
          Reporting violations
        </h2>
        <p>
          If you have discovered and would like to report a violation of this Policy,
          please contact us immediately. We will investigate the situation and
          provide you with full assistance.
        </p>
        <h2>
          Changes and amendments
        </h2>
        <p>
          We reserve the right to modify this Policy or its terms relating to the
          Services at any time, effective upon posting of an updated version of this
          Policy on the Services. When we do, we will post a notification within the
          Services.  Continued use of the Services after any such changes shall
          constitute your consent to such changes.
        </p>
        <h2>
          Acceptance of this policy
        </h2>
        <p>
          You acknowledge that you have read this Policy and agree to all its terms
          and conditions. By accessing and using the Services you agree to be bound
          by this Policy. If you do not agree to abide by the terms of this Policy,
          you are not authorized to access or use the Services.
        </p>
        <h2>
          Contacting us
        </h2>
        <p>
          If you would like to contact us to understand more about this Policy or
          wish to contact us concerning any matter relating to it, you may write a
          letter to 4960 S Gilbert Rd Ste. 1-296, Chandler​, AZ, 85249-5982
        </p>
        <p>
          This document was last updated on 1 April 2025
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/terms_and_conditions';
</style>
